import Calendar from "../payment/calendar";
import Notify from "./../notify";
import Litepicker from "./../litepicker";
Date.prototype.getWeekMounth = function() {

    var nth = 0;
    var timestamp = this.getTime();
    var month = this.getMonth();
    var m = month;
    while (m == month) {
        nth++;

        m = new Date(timestamp - nth * 604800000).getMonth();
    }

    return nth - 1;


}
Date.prototype.getWeekYear = function() {
    var d = new Date(Date.UTC(this.getFullYear(), this.getMonth(), this.getDate()));
    var dayNum = d.getUTCDay() || 7;
    d.setUTCDate(d.getUTCDate() + 4 - dayNum);
    var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    return Math.ceil((((d - yearStart) / 86400000) + 1) / 7)
};

export default class CalendarObject extends Calendar {
    constructor(id, mounth = false, year = false, useEditCell = false, loadDates = false) {

        super(id, mounth, year, false);
        this.datePickerEndDate = null;
        this.selectedYear = null;
        this.selectedMounth = null;
        this.selectedDay = null;
        this.popupId = "object-create-popup";
        this.popup = null;
        this.dates = {};
        this.buildDates = {};
        this.formData = [];
        this.modalObjectCreate = null;
        // this.modalCellDelete = new Foundation.Reveal($("#object-cell-delete"));
        this.modalCellDelete = null;
        this.globalDateCreateStart = new Date();
        this.repeatDataIsActive = false;
        this.nextYear;
        this.dateForDelete = null;
        this.useEditCell = useEditCell;
        this.pickerEditDate = null;
        if (loadDates) {
            this.loadDates();
            this.rebuildDays();
        }
    }
    loadDates() {
        let instance = this;
        let data = [];
        $.ajax({
            method: "POST",
            url: "/themes/ahtilahti/ajax/object_edit.php",
            async: false,
            data: {
                action: "get-dates",
                data: {
                    id: $(".object-edit").attr("data-id"),
                },
            },
            success: function(response) {

                let res;
                typeof response === "string" ?
                    (res = $.parseJSON(response)) :
                    (res = response);
                if (res.success == true) {
                    instance.buildDates = res.data;
                }


            },

            error(xhr, status, error) {
                console.log(error);
            },
        });

    }
    openModalRepeat(edit = false) {

        this.pickerEditDate = null;


        if (this.modalObjectCreate) {
            this.modalObjectCreate.open();
        } else {
            this.modalObjectCreate = new Foundation.Reveal($("#object-create-popup"));
            this.modalObjectCreate.open();
        }

        this.clearRepeatForm();

        $(".days-repeat li.active").each(function(index) {
            $(this).removeClass("active");
        });

        let weekDayEng = "";
        let weekDayRus = "";
        let numberWeek = "";
        let numberDay = "";

        if (edit) {
            let editDate = new Date(new Date().setTime(this.elemForEdit));

            weekDayEng = new Intl.DateTimeFormat('en-US', { weekday: 'long' }).format(editDate).toLowerCase();
            weekDayRus = new Intl.DateTimeFormat('ru-RU', { weekday: 'long' }).format(editDate).toLowerCase();
            numberWeek = editDate.getWeekMounth();
            numberDay = editDate.getDate();
        } else {
            weekDayEng = new Intl.DateTimeFormat('en-US', { weekday: 'long' }).format(this.globalDateCreateStart).toLowerCase();
            weekDayRus = new Intl.DateTimeFormat('ru-RU', { weekday: 'long' }).format(this.globalDateCreateStart).toLowerCase();
            numberWeek = this.globalDateCreateStart.getWeekMounth();
            numberDay = this.globalDateCreateStart.getDate();
        }



        var namesWeekNumberDays = [
            "Ежемесячно перв. " + weekDayRus,
            "Ежемесячно втор. " + weekDayRus,
            "Ежемесячно " + weekDayRus + " кажд. 3-й недели",
            "Ежемесячно  - " + weekDayRus + " кажд. 4-й недели",
            "Ежемесячно в последн. " + weekDayRus
        ];
        $(".mounthly-repeat").empty();
        $(".mounthly-repeat").append("<option value='" + numberDay + "'>Ежемесячно - " + numberDay + "-го числа</option>");
        $(".mounthly-repeat").append("<option value='" + weekDayEng + "-" + numberWeek + "' >" + namesWeekNumberDays[numberWeek] + "</option>");


        $(".days-repeat li[value='" + weekDayEng + "']").addClass("active");
        $("#weekdays").val(weekDayEng);

    }
    getDateIntervalToMounthdays(currentDate, endDate, mounthly, countInterval) {

        let weekDayEng = null;
        let range = [];
        let date = currentDate;
        let currentWeekMounth = date.getWeekMounth();
        let currentWeekYear = null;
        let mounth = mounthly.split("-");
        let dayWeek = null;
        let day = null;
        let type = 0;
        let mounthCounter = 0;
        let step = countInterval;
        if (mounth.length > 1) {
            dayWeek = mounth[0];
            day = mounth[1];
            type = 2;
        } else {
            type = 1;
            day = mounth[0];
        }
        let startMounth = date.getMonth();
        let i = 0;
        while (new Date(date.getFullYear(), date.getMonth(), date.getDate()) <= new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate())) {

            currentWeekYear = date.getWeekYear();

            if (date.getMonth() != startMounth) {
                startMounth = date.getMonth();
                mounthCounter++;

            }
            if (mounthCounter % step == 0) {
                if (type == 1) {
                    if (date.getDate() == day) {
                        range.push(new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime());
                    }
                }
                if (type == 2) {
                    let weekDayEng = new Intl.DateTimeFormat('en-US', { weekday: 'long' }).format(date).toLowerCase();

                    if (date.getWeekMounth() == day && dayWeek == weekDayEng) {
                        range.push(new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime());
                    }

                }
            }

            i++;
            date.setDate(date.getDate() + 1);

        }

        return range

    }

    getDateIntervalToMounthdaysAfter(currentDate, mounthly, countInterval, countIntervalAfter) {
        let range = [];
        let date = currentDate;
        let currentWeekYear = null;
        let mounth = mounthly.split("-");
        let dayWeek = null;
        let day = null;
        let type = 0;
        let weekDayEng = null;
        let mounthCounter = 0;
        let step = countInterval;
        if (mounth.length > 1) {
            dayWeek = mounth[0];
            day = mounth[1];
            type = 2;
        } else {
            type = 1;
            day = mounth[0];
        }
        let countRepeat = 0;

        let startMounth = date.getMonth();
        let i = 0;

        while (new Date(date.getFullYear(), date.getMonth(), date.getDate())) {

            currentWeekYear = date.getWeekYear();

            if (date.getMonth() != startMounth) {
                startMounth = date.getMonth();
                mounthCounter++;
            }

            if (mounthCounter % step == 0) {
                if (type == 1) {

                    if (date.getDate() == day) {

                        countRepeat++;
                        range.push(new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime());
                    }
                }
                if (type == 2) {
                    weekDayEng = new Intl.DateTimeFormat('en-US', { weekday: 'long' }).format(date).toLowerCase();

                    if (date.getWeekMounth() == day && dayWeek == weekDayEng) {
                        countRepeat++;
                        range.push(new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime());
                    }

                }
            }

            i++;
            date.setDate(date.getDate() + 1);
            if (countRepeat == parseInt(countIntervalAfter)) {

                break;

            }


        }
        return range;

    }


    getDateIntervalToWeekdays(currentDate, endDate, weekdays, countInterval) {
        let range = [];
        let date = currentDate;
        let currentWeekYear = null;

        let weekDayEng = null;
        let step = countInterval;
        let week = 0;
        let i = 0;
        while (new Date(date.getFullYear(), date.getMonth(), date.getDate()) <= new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate())) {
            if (i == 7) {
                week++;
                i = 0;
            }
            currentWeekYear = date.getWeekYear();
            if (week % step == 0) {

                weekDayEng = new Intl.DateTimeFormat('en-US', { weekday: 'long' }).format(date).toLowerCase();
                if (weekdays) {
                    let weekDaysArray = weekdays.split(",");
                    if (weekDaysArray.includes(weekDayEng)) {

                        range.push(new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime());

                    }
                }

            }
            i++;
            date.setDate(date.getDate() + 1);
        }
        return range
    }

    getDateIntervalToWeekdaysAfter(currentDate, weekdays, countInterval, countIntervalAfter) {

        let range = [];
        let date = currentDate;
        let currentWeekYear = null;

        let weekDayEng = null;
        let step = countInterval;
        let week = 0;
        let i = 0;
        let countRepeat = 0;
        while (new Date(date.getFullYear(), date.getMonth(), date.getDate())) {
            if (i == 7) {
                week++;
                i = 0;
            }
            currentWeekYear = date.getWeekYear();
            if (week % step == 0) {

                weekDayEng = new Intl.DateTimeFormat('en-US', { weekday: 'long' }).format(date).toLowerCase();
                if (weekdays) {

                    let weekDaysArray = weekdays.split(",");
                    if (weekDaysArray.includes(weekDayEng)) {
                        countRepeat++;
                        range.push(new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime());
                    }
                }
            }
            i++;
            date.setDate(date.getDate() + 1);
            if (countRepeat == parseInt(countIntervalAfter)) {

                break;

            }


        }
        return range;
    }

    getDateIntervalToDaysdays(currentDate, endDate, countInterval) {

        let range = [];
        let date = currentDate;
        let step = countInterval;
        let i = 0;

        while (new Date(date.getFullYear(), date.getMonth(), date.getDate()) <= new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate())) {

            if (i % step == 0) {
                range.push(new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime());
            }
            i++;
            date.setDate(date.getDate() + 1);


        }
        return range;
    }

    getDateIntervalToDaysdaysAfter(currentDate, countInterval, countIntervalAfter) {

        let range = [];
        let date = currentDate;
        let step = countInterval;
        let i = 0;
        let countRepeat = 0;

        while (new Date(date.getFullYear(), date.getMonth(), date.getDate())) {

            if (i % step == 0) {
                countRepeat++;
                range.push(new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime());
            }
            i++;
            date.setDate(date.getDate() + 1);

            if (countRepeat == countIntervalAfter) {
                break;
            }
        }

        return range;
    }
    getDateIntervalToYeardays(currentDate, endDate, countInterval) {
        let range = [];
        let selectedDate = new Date(currentDate);
        let onewSelectedDate = new Date(selectedDate);
        let date = new Date(currentDate);
        let step = countInterval;
        let i = 0;
        let yearCount = 0;

        while (new Date(date.getFullYear(), date.getMonth(), date.getDate()) <= new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate())) {

            if (date.getFullYear() != onewSelectedDate.getFullYear()) {
                yearCount++;
                onewSelectedDate.setFullYear(onewSelectedDate.getFullYear() + 1)
            }

            if (yearCount % step == 0) {

                if (selectedDate.getMonth() == date.getMonth() && selectedDate.getDate() == date.getDate()) {

                    range.push(new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime());
                }

            }

            i++;
            date.setDate(date.getDate() + 1);
        }


        return range;

    }
    getDateIntervalToYeardaysAfter(currentDate, countInterval, countIntervalAfter) {

        let range = [];
        let selectedDate = new Date(currentDate);
        let onewSelectedDate = new Date(selectedDate);
        let date = new Date(currentDate);
        let step = countInterval;
        let i = 0;
        let yearCount = 0;
        let yearCountRepeat = 0;

        while (new Date(date.getFullYear(), date.getMonth(), date.getDate())) {

            if (date.getFullYear() != onewSelectedDate.getFullYear()) {
                yearCount++;
                onewSelectedDate.setFullYear(onewSelectedDate.getFullYear() + 1)
            }

            if (yearCount % step == 0) {

                if (selectedDate.getMonth() == date.getMonth() && selectedDate.getDate() == date.getDate()) {
                    yearCountRepeat++;
                    range.push(new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime());
                }

            }

            i++;
            date.setDate(date.getDate() + 1);
            if (yearCountRepeat == countIntervalAfter) {
                break;
            }
        }


        return range;
    }

    initRepeatDates() {


        if (this.dates) {


            for (let key in this.dates) {
                if (this.dates[key]["norepeat"] == "on") {
                    if (!this.buildDates[key]) {
                        this.buildDates[key] = this.dates[key];
                    }
                } else {
                    let date = new Date(new Date().setTime(key));
                    let endDate = null;


                    switch (this.dates[key]["repeat-type"]) {
                        // День
                        case "day":
                            //  Никогда (+ 2 года к текущей дате) - день
                            if (this.dates[key]["repeat-end"] == "never" && !this.buildDates[key]) {

                                endDate = new Date(date.getFullYear() + 2, date.getMonth(), date.getDate());
                                this.buildDates[key] = this.dates[key];
                                this.buildDates[key]["interval"] = this.getDateIntervalToDaysdays(date, endDate, this.dates[key]["repeat-day"]);
                            }
                            // Конкретная дата  - день 
                            if (this.dates[key]["repeat-end"] == "data" && !this.buildDates[key]) {
                                endDate = new Date(new Date().setTime(this.dates[key]["end-data"]));
                                this.buildDates[key] = this.dates[key];
                                this.buildDates[key]["interval"] = this.getDateIntervalToDaysdays(date, endDate, this.dates[key]["repeat-day"]);
                            }

                            // После n повторов - день


                            if (this.dates[key]["repeat-end"] == "after" && !this.buildDates[key]) {
                                this.buildDates[key] = this.dates[key];
                                this.buildDates[key]["interval"] = this.getDateIntervalToDaysdaysAfter(date, this.dates[key]["repeat-day"], this.dates[key]["count-end"]);
                            }
                            break;
                            // Тип - месяц 
                        case "mounth":
                            //  Никогда (+ 2 года к текущей дате) - месяц
                            if (this.dates[key]["repeat-end"] == "never" && !this.buildDates[key]) {
                                endDate = new Date(date.getFullYear() + 2, date.getMonth(), date.getDate());
                                this.buildDates[key] = this.dates[key];
                                this.buildDates[key]["interval"] = this.getDateIntervalToMounthdays(date, endDate, this.dates[key]["repeat-mounthly"], this.dates[key]["repeat-day"]);

                            }
                            //  Конкретная дата - месяц
                            if (this.dates[key]["repeat-end"] == "data" && !this.buildDates[key]) {
                                endDate = new Date(new Date().setTime(this.dates[key]["end-data"]));
                                this.buildDates[key] = this.dates[key];
                                this.buildDates[key]["interval"] = this.getDateIntervalToMounthdays(date, endDate, this.dates[key]["repeat-mounthly"], this.dates[key]["repeat-day"]);
                            }
                            // После n повторов - месяц


                            if (this.dates[key]["repeat-end"] == "after" && !this.buildDates[key]) {
                                this.buildDates[key] = this.dates[key];
                                this.buildDates[key]["interval"] = this.getDateIntervalToMounthdaysAfter(date, this.dates[key]["repeat-mounthly"], this.dates[key]["repeat-day"], this.dates[key]["count-end"]);


                            }

                            break;
                            // Тип - неделя
                        case "week":



                            //  Никогда (+ 2 года к текущей дате) - неделя
                            if (this.dates[key]["repeat-end"] == "never" && !this.buildDates[key]) {
                                endDate = new Date(date.getFullYear() + 2, date.getMonth(), date.getDate());
                                this.buildDates[key] = this.dates[key];
                                this.buildDates[key]["interval"] = this.getDateIntervalToWeekdays(date, endDate, this.dates[key]["repeat-weekdays"], this.dates[key]["repeat-day"]);

                            }
                            // Конкретная дата - неделя
                            if (this.dates[key]["repeat-end"] == "data" && !this.buildDates[key]) {
                                endDate = new Date(new Date().setTime(this.dates[key]["end-data"]));
                                this.buildDates[key] = this.dates[key];
                                this.buildDates[key]["interval"] = this.getDateIntervalToWeekdays(date, endDate, this.dates[key]["repeat-weekdays"], this.dates[key]["repeat-day"]);

                            }

                            // После n повторов - неделя
                            if (this.dates[key]["repeat-end"] == "after" && !this.buildDates[key]) {
                                this.buildDates[key] = this.dates[key];
                                this.buildDates[key]["interval"] = this.getDateIntervalToWeekdaysAfter(date, this.dates[key]["repeat-weekdays"], this.dates[key]["repeat-day"], this.dates[key]["count-end"]);
                            }

                            break;
                            //  ГОД
                        case "year":
                            //  Никогда (+ 2 года к текущей дате) - год
                            if (this.dates[key]["repeat-end"] == "never" && !this.buildDates[key]) {
                                endDate = new Date(date.getFullYear() + 10, date.getMonth(), date.getDate());
                                this.buildDates[key] = this.dates[key];
                                this.buildDates[key]["interval"] = this.getDateIntervalToYeardays(date, endDate, this.dates[key]["repeat-day"]);
                            }

                            // Конкретная дата - год
                            if (this.dates[key]["repeat-end"] == "data" && !this.buildDates[key]) {
                                endDate = new Date(new Date().setTime(this.dates[key]["end-data"]));
                                this.buildDates[key] = this.dates[key];
                                this.buildDates[key]["interval"] = this.getDateIntervalToYeardays(date, endDate, this.dates[key]["repeat-day"]);
                            }
                            // После n повторов - год
                            if (this.dates[key]["repeat-end"] == "after" && !this.buildDates[key]) {
                                this.buildDates[key] = this.dates[key];
                                this.buildDates[key]["interval"] = this.getDateIntervalToYeardaysAfter(date, this.dates[key]["repeat-day"], this.dates[key]["count-end"]);
                            }

                            break;
                        default:
                            break;
                    }

                }
            }



        }


    }
    rebuildDays() {


        if (this.buildDates) {
            let control = "<div class='cell-control'>";
            if (this.useEditCell) {
                control += "<span class='cell-control__edit'><i class='far fa-edit'></i></span>";
            }
            control += "<span class='cell-control__delete'><i class='far fa-trash-alt'></i></span></div>";

            for (let key in this.buildDates) {

                if (this.buildDates[key]["interval"]) {
                    for (let k in this.buildDates[key]["interval"]) {
                        if ($("[data-key='" + this.buildDates[key]["interval"][k] + "']").last().attr("data-use") != "Y") {

                            let newelement = $("[data-key='" + this.buildDates[key]["interval"][k] + "']").clone();
                            newelement.removeClass("calendar-date-disabled");
                            newelement.addClass("calendar-date calendar-date-used");
                            newelement.find(".price").val(this.buildDates[key]["repeat-price"] + "");
                            newelement.find(".price").attr("data-oldprice", this.buildDates[key]["repeat-price"]);
                            // newelement.find(".currency").html("&nbsp;<i class='fas fa-ruble-sign'></i>");

                            newelement.attr("data-use", "Y");
                            $("[data-key='" + this.buildDates[key]["interval"][k] + "']").addClass("hide");
                            $("[data-key='" + this.buildDates[key]["interval"][k] + "']").after(newelement);
                            let controlButtons = $(control);
                            newelement.append(controlButtons);

                        } else {

                            let element = $("[data-key='" + this.buildDates[key]["interval"][k] + "']").last();
                            element.find(".price").val(this.buildDates[key]["repeat-price"] + "");
                        }
                    }

                } else {
                    if ($("[data-key='" + key + "']").last().attr("data-use") != "Y") {

                        let newelement = $("[data-key='" + key + "']").clone();
                        newelement.removeClass("calendar-date-disabled");
                        newelement.addClass("calendar-date calendar-date-used");
                        newelement.find(".price").val(this.buildDates[key]["repeat-price"]);
                        newelement.find(".price").attr("data-oldprice", this.buildDates[key]["repeat-price"]);


                        // newelement.find(".currency").html("&nbsp;<i class='fas fa-ruble-sign'></i>");
                        newelement.attr("data-use", "Y");
                        $("[data-key='" + key + "']").addClass("hide");
                        $("[data-key='" + key + "']").after(newelement);
                        let controlButtons = $(control);
                        newelement.append(controlButtons);
                    } else {

                        let element = $("[data-key='" + key + "']").last();
                        element.find(".price").val(this.buildDates[key]["repeat-price"] + "");
                    }
                }
            }
        }


    }
    setDates(day, mounth, year, price) {
        // this.dates.push({ day: day, mounth: mounth, year: year, price: price });
        // this.dates[day + mounth + year] = { day: day, mounth: mounth, year: year };
    }
    getMinStaticDateForOrder() {
        return {
            mounth: new Date().getMonth() + 1,
            year: new Date().getFullYear()
        }
    }
    getDatesForOrder() {
        return [];
    }
    createMonth() {
        let inst = this;
        let mounthContainer = document.createElement("div");
        mounthContainer.classList.add(
            "sect",
            "grid-x",
            "grid-padding-x",
            "align-justify",
            "align-middle"
        );
        if (
            this.staticMinDateMounth < this.currentMonth ||
            this.staticMinDateYear < this.currentYear
        ) {
            let leftArrow = document.createElement("div");
            leftArrow.classList.add("cell", "shrink");

            let linkLeftArrow = document.createElement("a");
            linkLeftArrow.classList.add("calendar-month-link");
            linkLeftArrow.innerHTML = "<i class='fas fa-chevron-left'>";
            leftArrow.appendChild(linkLeftArrow);
            mounthContainer.appendChild(leftArrow);

            linkLeftArrow.addEventListener("click", function(e) {
                e.preventDefault();

                inst.currentMonth = inst.currentMonth - 1;

                if (inst.currentMonth < 0) {
                    inst.currentMonth = 11;
                    inst.currentYear = parseInt(inst.currentYear) - 1;
                }

                inst.init(true);
            });



        }

        let rightArrow = document.createElement("div");
        rightArrow.classList.add("cell", "shrink");

        let linkRightArrow = document.createElement("a");
        linkRightArrow.classList.add("calendar-month-link");
        linkRightArrow.innerHTML = "<i class='fas fa-chevron-right'>";
        rightArrow.appendChild(linkRightArrow);

        linkRightArrow.addEventListener("click", function(e) {
            e.preventDefault();


            inst.currentMonth = inst.currentMonth + 1;


            if (inst.currentMonth > 11) {
                inst.currentMonth = 0;
                inst.currentYear = parseInt(inst.currentYear) + 1;
            }



            inst.init(true);
        });

        let mounthName = document.createElement("div");
        mounthName.classList.add("cell", "auto", "calendar-month-title");

        //  if (this.currentYear != this.date.getFullYear()) {

        // this.monthes[this.currentMonth] =
        // this.monthes[this.currentMonth] + " " + this.currentYear;
        //  }

        mounthName.innerHTML = this.monthes[this.currentMonth] + " " + this.currentYear;

        mounthContainer.appendChild(mounthName);
        mounthContainer.appendChild(rightArrow);

        return mounthContainer;
    }

    setSelectedDate(y, m, d) {
        this.selectedDay = d;
        this.selectedMounth = m;
        this.selectedYear = y;
    }

    cellClick(instance, element) {
        instance.setSelectedDate(instance.firstDay.getFullYear(), instance.firstDay.getMonth() - 1, parseInt(element.getAttribute("data-day")));
        instance.globalDateCreateStart = new Date(instance.selectedYear, instance.selectedMounth, instance.selectedDay);
        instance.openModalRepeat();
        $("#" + instance.popupId).find(".button_edit").addClass("button_set");
        $("#" + instance.popupId).find(".button_set").removeClass("button_edit");


        instance.reInitLitepicker();

        if (instance.datePickerEndDate) {
            instance.datePickerEndDate.destroy();
        }


    }


    createDays() {

        let instance = this;
        instance.firstDay = new Date(this.currentYear, this.currentMonth, 1);
        instance.firstDayWeek = instance.firstDay.getDay();
        this.next = this.firstDay.getMonth();
        this.nextYear = this.firstDay.getFullYear();
        instance.t = instance.firstDayWeek - 1;
        if (instance.t < 0) {
            instance.t = 6;
        }
        let daysCalendar = document.createElement("div");

        daysCalendar.classList.add("calendar-dates");
        let a = 0;

        while (this.firstDay.getMonth() == this.currentMonth) {
            let firstDay = this.firstDay;
            let i = 0;



            let row = document.createElement("div");
            row.classList.add("grid-x", "small-up-7", "text-center");


            while (i < 7) {
                let col;
                let day;
                if (a == 0) {
                    if (i < this.t) {
                        col = document.createElement("div");
                        col.classList.add("cell", "calendar-date-none");
                        col.innerHTML = "";
                        col.setAttribute("data-day", this.firstDay.getDate());
                    } else {
                        let colClass = "calendar-date-disabled";
                        col = document.createElement("div");
                        if (new Date(this.firstDay.getFullYear(), this.firstDay.getMonth(), this.firstDay.getDate()) < new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())) {
                            colClass = "calendar-date-none";
                        } else {
                            col.setAttribute("data-key", new Date(firstDay.getFullYear(), firstDay.getMonth(), this.firstDay.getDate()).getTime());

                            col.addEventListener('click', () => instance.cellClick(instance, col));

                        }
                        col.classList.add("cell", colClass);
                        col.innerHTML = "<span class='day'>" + this.firstDay.getDate() + "</span>";
                        col.innerHTML += "<input  class='price' readonly /><span class='currency'></span><div class='control-for-price'><span class='price-success'><i class='fas fa-check'></i></span> <span class='price-cancel'><i class='fas fa-times'></i></span></div>";
                        col.setAttribute("data-day", this.firstDay.getDate());

                        this.firstDay.setDate(this.firstDay.getDate() + 1);
                    }
                } else {

                    if (this.next > this.currentMonth || this.nextYear > this.currentYear) {
                        break;
                    }
                    let colClass = "calendar-date-disabled";
                    col = document.createElement("div");
                    if (new Date(this.firstDay.getFullYear(), this.firstDay.getMonth(), this.firstDay.getDate()) < new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())) {
                        colClass = "calendar-date-none";

                    } else {

                        col.setAttribute("data-key", new Date(firstDay.getFullYear(), firstDay.getMonth(), this.firstDay.getDate()).getTime());

                        col.addEventListener('click', () => instance.cellClick(instance, col));

                    }
                    col.classList.add("cell", colClass);

                    col.innerHTML = "<span class='day'>" + this.firstDay.getDate() + "</span>";
                    col.innerHTML += "<input class='price' readonly /><span class='currency'></span><div class='control-for-price'><span class='price-success'><i class='fas fa-check'></i></span> <span class='price-cancel'><i class='fas fa-times'></i></span></div>";
                    col.setAttribute("data-day", this.firstDay.getDate());
                    this.firstDay.setDate(this.firstDay.getDate() + 1);
                    this.next = this.firstDay.getMonth();
                    this.nextYear = this.firstDay.getFullYear();


                }
                row.appendChild(col);
                i++;

            }

            daysCalendar.appendChild(row);
            a++;

        }


        return daysCalendar;
    }

    reInitLitepicker(destroy = true) {
        if (this.datePickerEndDate) {
            this.datePickerEndDate.destroy();
        }

        let instance = this;
        let startDate = instance.getDateForRepeat();
        if (instance.pickerEditDate) {
            startDate = instance.pickerEditDate;
        }
        let datapicker = new Litepicker({
            startDate: startDate,
            minDate: new Date(),
            onRender: function() {
                if (this.options.startDate) {
                    $("[data-datepicker-create]").attr("data-dateTime", this.options.startDate.dateInstance.getTime());
                }
            },
            onShow: function() {
                instance.reInitLitepickerPosition($(this.picker));
                $("[data-datepicker-create]").attr("data-dateTime", this.options.startDate.dateInstance.getTime());

            },
            onSelect: function(date) {
                $("[data-datepicker-create]").attr("data-dateTime", new Date(date).getTime());


            },
            element: $("[data-datepicker-create]")[0],
            lang: "ru-RU",
            format: "D MMM YYYY",
            singleMode: true
        });

        if (destroy == true) {
            datapicker.destroy();
        }
        instance.datePickerEndDate = datapicker;
        return instance.datePickerEndDate;
    }

    reInitLitepickerPosition(picker) {

        let offset = $("[data-datepicker-create]").offset();
        let heightField = $("[data-datepicker-create]").outerHeight();
        // $(picker).css({ top: offset.top + heightField + "px", position: "fixed" });
        $(picker).css({ position: "fixed" });
        // 
    }


    inArray(needle, haystack) {
        let length = haystack.length;
        for (let i = 0; i < length; i++) {
            if (haystack[i] == needle) return i;
        }
        return false;
    }


    deleteDatesFromResult(date) {


        let newDateKey = date;
        let newDateParams = this.buildDates[date];
        let currentAddDates = newDateParams;
        let params = null;
        delete this.buildDates[date];

        for (let key in currentAddDates["interval"]) {


            for (let data in this.buildDates) {

                if (this.buildDates[data]["interval"] && this.buildDates[data]["interval"].length) {
                    for (let k in this.buildDates[data]["interval"]) {

                        if (currentAddDates["interval"][key] == this.buildDates[data]["interval"][k]) {

                            if (this.buildDates[data]["interval"].length <= 1) {
                                delete this.buildDates[data];
                                delete this.dates[data];
                            } else {
                                params = this.buildDates[data];
                                let keyOld = data;

                                this.buildDates[data]["interval"].splice(k, 1);

                                delete this.buildDates[data];
                                delete this.dates[data];

                                this.dates[keyOld] = params;
                                this.buildDates[keyOld] = params;
                                // if (this.buildDates[this.dateForDelete]["interval"][0] && this.buildDates[this.dateForDelete]["interval"].length) {
                                //     this.buildDates[this.buildDates[this.dateForDelete]["interval"][0]] = params;
                                // }


                            }
                        }


                    }

                } else {
                    delete this.buildDates[data];

                    delete this.dates[data];

                }

            }
        }

        this.buildDates[newDateKey] = newDateParams;
        // 

    }

    initRepeatData() {

        let instance = this;
        var datapicker = null;

        // datapicker = instance.reInitLitepicker();

        $(".days-repeat li.active").each(function(index) {
            $(this).removeClass("active");
        });




        $(".select-repeat").on("change", function() {
            let attr = $(this).data("input");

            switch (attr) {
                case "end-data":
                    $("input[name='" + attr + "']").prop("disabled", false);
                    $("input[name='count-end']").prop("disabled", true);

                    datapicker = instance.reInitLitepicker(false);
                    break;
                case "end-after":
                    instance.datePickerEndDate.destroy();
                    $("input[name='count-end']").prop("disabled", false);
                    $("input[name='end-data']").prop("disabled", true);

                    break;
                default:

                    instance.datePickerEndDate.destroy();
                    $("input[name='count-end']").prop("disabled", true);
                    $("input[name='end-data']").prop("disabled", true);
                    break;

            }
        });

        $(".days-repeat li").on("click", function(e) {
            e.preventDefault();


            $(this).toggleClass("active");

            let weekdays = [];
            if ($(".days-repeat li.active").length == 0) {
                $(this).addClass("active");
            }
            $(".days-repeat li.active").each(function(index) {
                weekdays[index] = $(this).attr("value")
            });
            $("#weekdays").val(weekdays.join(","));
        });


        $("#norepeat").on("change", function(e) {
            e.preventDefault();
            $("#block-repeat").toggleClass("hide");
        });


        $(".repeat-type").on("change", function() {
            let globalDateCreateStart = new Date(instance.globalDateCreateStart);
            switch ($(this).val()) {

                case "day":
                    $(".mounthly-repeat-container").addClass("hide");
                    $(".days-repeat-container").addClass("hide");
                    $("input[name='count-end']").val("30");

                    if (datapicker) {
                        datapicker.destroy();
                    }
                    let countDays = $("input[name='count-end']").val();
                    datapicker = new Litepicker({
                        startDate: new Date(globalDateCreateStart.setDate(globalDateCreateStart.getDate() + parseInt(countDays))),
                        minDate: new Date(),
                        onRender: function() {
                            $("[data-datepicker-create]").attr("data-dateTime", this.options.startDate.dateInstance.getTime());
                        },
                        onShow: function(element) {
                            instance.reInitLitepickerPosition($(this.picker));
                            $("[data-datepicker-create]").attr("data-dateTime", this.options.startDate.dateInstance.getTime());
                        },
                        onSelect: function(date) {
                            $("[data-datepicker-create]").attr("data-dateTime", new Date(date).getTime());

                        },
                        lang: "ru-RU",
                        format: "D MMM YYYY",
                        singleMode: true,
                    });


                    if ($("input[name='end-data']").attr("disabled")) {
                        datapicker.destroy();
                    }

                    break;

                case "week":
                    $(".mounthly-repeat-container").addClass("hide");
                    $(".days-repeat-container").removeClass("hide");

                    $("input[name='count-end']").val("13");


                    if (datapicker) {
                        datapicker.destroy();
                    }
                    let countWeek = $("input[name='count-end']").val();

                    datapicker = new Litepicker({
                        startDate: new Date(globalDateCreateStart.setDate(globalDateCreateStart.getDate() + (parseInt(countWeek) * 7))),
                        minDate: new Date(),
                        element: $("[data-datepicker-create]")[0],
                        onRender: function() {
                            $("[data-datepicker-create]").attr("data-dateTime", this.options.startDate.dateInstance.getTime());
                        },
                        onShow: function(element) {
                            instance.reInitLitepickerPosition($(this.picker));
                            $("[data-datepicker-create]").attr("data-dateTime", this.options.startDate.dateInstance.getTime());
                        },
                        onSelect: function(date) {
                            $("[data-datepicker-create]").attr("data-dateTime", new Date(date).getTime());

                        },
                        lang: "ru-RU",
                        format: "D MMM YYYY",
                        singleMode: true,
                    });


                    if ($("input[name='end-data']").attr("disabled")) {
                        datapicker.destroy();
                    }

                    break;


                case "mounth":
                    $(".days-repeat-container").addClass("hide");

                    $(".mounthly-repeat-container").removeClass("hide");
                    $("input[name='count-end']").val("12");


                    if (datapicker) {
                        datapicker.destroy();
                    }
                    let countMounths = $("input[name='count-end']").val();

                    datapicker = new Litepicker({

                        startDate: new Date(globalDateCreateStart.setMonth(globalDateCreateStart.getMonth() + parseInt(countMounths))),
                        minDate: new Date(),
                        element: $("[data-datepicker-create]")[0],
                        onRender: function() {
                            $("[data-datepicker-create]").attr("data-dateTime", this.options.startDate.dateInstance.getTime());
                        },
                        onShow: function(element) {
                            instance.reInitLitepickerPosition($(this.picker));
                            $("[data-datepicker-create]").attr("data-dateTime", this.options.startDate.dateInstance.getTime());
                        },
                        onSelect: function(date) {
                            $("[data-datepicker-create]").attr("data-dateTime", new Date(date).getTime());

                        },
                        lang: "ru-RU",
                        format: "D MMM YYYY",
                        singleMode: true,
                    });


                    if ($("input[name='end-data']").attr("disabled")) {
                        datapicker.destroy();
                    }



                    break;

                case "year":

                    $(".mounthly-repeat-container").addClass("hide");
                    $(".days-repeat-container").addClass("hide");
                    $("input[name='count-end']").val("5");


                    if (datapicker) {
                        datapicker.destroy();
                    }
                    let countYears = $("input[name='count-end']").val();

                    datapicker = new Litepicker({
                        startDate: new Date(globalDateCreateStart.setFullYear(globalDateCreateStart.getFullYear() + parseInt(countYears))),
                        minDate: new Date(),
                        element: $("[data-datepicker-create]")[0],
                        onRender: function() {
                            $("[data-datepicker-create]").attr("data-dateTime", this.options.startDate.dateInstance.getTime());
                        },
                        onShow: function(element) {
                            instance.reInitLitepickerPosition($(this.picker));
                            $("[data-datepicker-create]").attr("data-dateTime", this.options.startDate.dateInstance.getTime());
                        },
                        onSelect: function(date) {
                            $("[data-datepicker-create]").attr("data-dateTime", new Date(date).getTime());

                        },
                        lang: "ru-RU",
                        format: "D MMM YYYY",
                        singleMode: true,
                    });

                    if ($("input[name='end-data']").attr("disabled")) {
                        datapicker.destroy();
                    }

                    break;

                default:
                    break;

            }

        });


        $("#" + this.popupId).on("click", ".button_set", function(e) {
            e.preventDefault();


            let data = instance.serializeDataRepeatForm();
            if (data) {

                if (data["repeat-end"] == "data") {

                    data["end-data"] = $("[data-datepicker-create]").attr("data-dateTime");
                }


                instance.modalObjectCreate.close();
                let newDate = new Date(instance.selectedYear, instance.selectedMounth, instance.selectedDay).getTime();

                instance.dates[newDate] = data;


                instance.clearRepeatForm();

                instance.initRepeatDates(true);

                instance.deleteDatesFromResult(newDate);






                instance.rebuildDays();



            }



        });

        $("#" + this.popupId).on("click", ".button_edit", function(e) {

            let data = instance.serializeDataRepeatForm();

            if (data) {


                if (data["repeat-end"] == "data") {

                    data["end-data"] = $("[data-datepicker-create]").attr("data-dateTime");
                }

                instance.modalObjectCreate.close();

                instance.clearRepeatForm();
                instance.editElements(data, instance.elemForEdit);

                instance.rebuildDays();

                new Notify("Даты успешно отредактированы", "success");

            }





            $("#" + instance.popupId).find(".button_edit").addClass("button_set");
            $("#" + instance.popupId).find(".button_set").removeClass("button_edit");

        });

        $(document).on("click", ".price", function(e) {
            e.preventDefault();

            if ($(this).closest(".calendar-date-used").attr("data-use")) {
                $(this).addClass("active");
                $(this).removeAttr("readonly");
                $(this).closest(".calendar-date-used").find(".control-for-price").css({ display: "block" });
            }

        });

        $(document).on("click", ".cell-control__edit", function(e) {
            e.preventDefault();
            let cell = $(this).closest(".calendar-date-used");
            instance.openEditForm(cell.attr("data-key"));
        });


        $(document).on("click", ".cell-control__delete", function(e) {
            e.preventDefault();
            if (!instance.modalCellDelete) {
                instance.modalCellDelete = new Foundation.Reveal($("#object-cell-delete"));
            }
            instance.modalCellDelete.open();
            instance.dateForDelete = $(this).closest(".calendar-date-used").attr("data-key");

        });

        $(document).on("click", ".button_cell_delete", function(e) {
            let type = $("input[name='cell-delete']:checked").val();

            let datesDelete = instance.checkOrderedDate(type);

            if (datesDelete.length) {
                $.ajax({
                    method: "POST",
                    url: "/themes/ahtilahti/ajax/object_edit.php",
                    data: {
                        action: "check-ordered-dates",
                        data: datesDelete,
                        id: $(".object-edit").attr("data-id")

                    },
                    success: function(response) {
                        let res;
                        typeof response === "string" ?
                            (res = $.parseJSON(response)) :
                            (res = response);
                        if (res.success == true) {
                            if (res.check == true) {
                                let question = "";
                                if (datesDelete.length > 1) {
                                    question = "Выбранные к удалению даты у текущего объекта существуют. Хотите продолжить? ";
                                } else {
                                    question = "Выбранная к удалению дата у текущего объекта существует. Хотите продолжить? ";
                                }
                                res = confirm(question);
                                instance.modalCellDelete.close();
                                if (res == true) {
                                    instance.checkEventSuccess().then(() => {
                                        instance.deleteDate(type);

                                    });
                                }
                                $("input[name='cell-delete']").first().prop("checked", true);
                                $("#block-period").addClass("hide");
                            } else {
                                instance.modalCellDelete.close();
                                instance.deleteDate(type);
                                $("input[name='cell-delete']").first().prop("checked", true);
                                $("#block-period").addClass("hide");
                            }
                        }
                    },
                    error(xhr, status, error) {
                        new Notify(error, "alert");
                    },
                });
            }
        });


        $(document).on("click", ".price-cancel", function(e) {
            let cell = $(this).closest(".calendar-date-used");
            let priceold = cell.find(".price").attr("data-oldprice");
            cell.find(".price").val(priceold);
            cell.find(".price").removeClass("active");
            cell.find(".price").attr("readonly", true);
            cell.find(".control-for-price").css({ display: "none" });
        });

        $(document).on("click", ".price-success", function(e) {
            let cell = $(this).closest(".calendar-date-used");
            let elemDate = cell.attr("data-key");
            let priceold = cell.find(".price").attr("data-oldprice");
            let newPrice = cell.find(".price").val();

            if (priceold != newPrice) {
                if (newPrice.trim() == "" || newPrice.trim() == 0) {
                    instance.dateForDelete = elemDate;
                    instance.deleteDate("current");
                } else {
                    instance.setNewPrice(newPrice, elemDate);
                }

            }
            cell.find(".price").removeClass("active");
            cell.find(".price").attr("readonly", true);
            cell.find(".control-for-price").css({ display: "none" });

        });


        instance.repeatDataIsActive = true;

    }




    openEditForm(key) {
        let instance = this;
        let checkDatePicker = false;
        let repickerDate = null;
        instance.elemForEdit = key;
        instance.openModalRepeat(true);

        let params = {};



        if (instance.buildDates[instance.elemForEdit]) {
            params = instance.buildDates[instance.elemForEdit];
        }


        if (!$.isEmptyObject(params)) {
            for (let p in params) {
                switch (p) {
                    case "norepeat":
                        if (params[p] == "0") {

                            $("input[name='" + p + "'").prop("checked", false);
                            $("#block-repeat").removeClass("hide");
                        } else {
                            instance.clearRepeatForm();

                        }
                        break;
                    case "repeat-day":
                        $("input[name='" + p + "'").val(params[p]);
                        break;
                    case "repeat-end":

                        $("input[value='" + params[p] + "'").prop("checked", true);
                        switch (params[p]) {
                            case "never":
                                $("input[name='end-data']").prop("disabled", true);
                                $("input[name='count-end']").prop("disabled", true);
                                repickerDate = instance.reInitLitepicker(false);
                                repickerDate.destroy();
                                break;
                            case "data":
                                $("input[name='end-data']").prop("disabled", false);
                                $("input[name='count-end']").prop("disabled", true);


                                instance.pickerEditDate = params["end-data"];
                                instance.reInitLitepicker(false);

                                break;
                            case "after":
                                $("input[name='end-data']").prop("disabled", true);
                                $("input[name='count-end']").prop("disabled", false);
                                $("input[name='count-end']").val(params['count-end']);
                                repickerDate = instance.reInitLitepicker(false);
                                repickerDate.destroy();


                                break;
                        }
                        break;

                    case "repeat-price":
                        $("input[name='" + p + "'").val(params[p]);
                        break;
                    case "repeat-type":

                        $(".repeat-type option[value='" + params[p] + "']").prop('selected', true);

                        switch (params[p]) {
                            case "day":
                            case "year":
                                $(".days-repeat-container").addClass("hide");
                                $(".mounthly-repeat-container").addClass("hide");
                                break;
                            case "week":
                                $(".days-repeat-container").removeClass("hide");
                                $(".mounthly-repeat-container").addClass("hide");
                                break;
                            case "mounth":


                                $(".days-repeat-container").addClass("hide");
                                $(".mounthly-repeat-container").removeClass("hide");
                                $(".mounthly-repeat option[value='" + params["repeat-mounthly"] + "']").prop('selected', true);

                                break;

                        }
                        break;
                    case "repeat-weekdays":
                        let weekDaysArr = [];

                        $(".days-repeat li").each(function() {
                            if (params[p].indexOf($(this).attr("value")) !== -1) {
                                $(this).addClass("active");
                                weekDaysArr.push($(this).attr("value"));
                            } else {
                                $(this).removeClass("active");
                            }
                            $(document).find("#weekdays").val(weekDaysArr.join(","));
                        });


                        break;
                    default:
                        break;
                }

            }

        }

        $("#" + instance.popupId).find(".button_set").addClass("button_edit");
        $("#" + instance.popupId).find(".button_edit").removeClass("button_set");





    }

    getInterval(obj, key) {
        let interval = [];

        if (obj["norepeat"] == "on") {
            interval = [];
        } else {
            let date = new Date(new Date().setTime(key));
            let endDate = null;


            switch (obj["repeat-type"]) {
                // День
                case "day":
                    //  Никогда (+ 2 года к текущей дате) - день
                    if (obj["repeat-end"] == "never") {
                        endDate = new Date(date.getFullYear() + 2, date.getMonth(), date.getDate());
                        interval = this.getDateIntervalToDaysdays(date, endDate, obj["repeat-day"]);
                    }
                    // Конкретная дата  - день 
                    if (obj["repeat-end"] == "data") {
                        endDate = new Date(new Date().setTime(obj["end-data"]));
                        interval = this.getDateIntervalToDaysdays(date, endDate, obj["repeat-day"]);
                    }

                    // После n повторов - день

                    if (obj["repeat-end"] == "after") {
                        interval = this.getDateIntervalToDaysdaysAfter(date, obj["repeat-day"], obj["count-end"]);
                    }
                    break;
                    // Тип - месяц 
                case "mounth":
                    //  Никогда (+ 2 года к текущей дате) - месяц
                    if (obj["repeat-end"] == "never") {
                        endDate = new Date(date.getFullYear() + 2, date.getMonth(), date.getDate());
                        interval = this.getDateIntervalToMounthdays(date, endDate, obj["repeat-mounthly"], obj["repeat-day"]);

                    }
                    //  Конкретная дата - месяц
                    if (obj["repeat-end"] == "data") {
                        endDate = new Date(new Date().setTime(obj["end-data"]));
                        // interval = this.getDateIntervalToMounthdays(date, endDate, obj["repeat-mounthly"], obj["repeat-day"]);

                        interval = this.getDateIntervalToWeekdays(date, endDate, obj["repeat-weekdays"], obj["repeat-day"]);



                    }
                    // После n повторов - месяц


                    if (obj["repeat-end"] == "after") {
                        interval = this.getDateIntervalToMounthdaysAfter(date, obj["repeat-mounthly"], obj["repeat-day"], obj["count-end"]);


                    }

                    break;
                    // Тип - неделя
                case "week":
                    //  Никогда (+ 2 года к текущей дате) - неделя
                    if (obj["repeat-end"] == "never") {
                        endDate = new Date(date.getFullYear() + 2, date.getMonth(), date.getDate());
                        interval = this.getDateIntervalToWeekdays(date, endDate, obj["repeat-weekdays"], obj["repeat-day"]);

                    }
                    // Конкретная дата - неделя
                    if (obj["repeat-end"] == "data") {
                        endDate = new Date(new Date().setTime(obj["end-data"]));
                        interval = this.getDateIntervalToWeekdays(date, endDate, obj["repeat-weekdays"], obj["repeat-day"]);

                    }

                    // После n повторов - неделя
                    if (obj["repeat-end"] == "after") {
                        interval = this.getDateIntervalToWeekdaysAfter(date, obj["repeat-weekdays"], obj["repeat-day"], obj["count-end"]);
                    }

                    break;
                    //  ГОД
                case "year":
                    //  Никогда (+ 2 года к текущей дате) - год
                    if (obj["repeat-end"] == "never") {
                        endDate = new Date(date.getFullYear() + 10, date.getMonth(), date.getDate());
                        interval = this.getDateIntervalToYeardays(date, endDate, obj["repeat-day"]);
                    }

                    // Конкретная дата - год
                    if (obj["repeat-end"] == "data") {
                        endDate = new Date(new Date().setTime(obj["end-data"]));
                        interval = this.getDateIntervalToYeardays(date, endDate, obj["repeat-day"]);
                    }
                    // После n повторов - год
                    if (obj["repeat-end"] == "after") {
                        interval = this.getDateIntervalToYeardaysAfter(date, obj["repeat-day"], obj["count-end"]);
                    }

                    break;
                default:
                    break;
            }

        }
        return interval;
    }
    editElements(data, key) {


        let instance = this;
        let interval = this.getInterval(data, key);


        // Если интервал не пустой
        if (interval.length) {


            // Запускаем цикл по интервалу
            // Проверяем, есть ли такая дата в нашем результатирующем массиве

            for (let val in interval) {


                // Запускаем цикл по датам билда
                for (let i in this.buildDates) {

                    // Если есть интервал
                    if (this.buildDates[i]["interval"]) {

                        // Запускаем цикл по интервалу 
                        for (let k = 0; k < this.buildDates[i]["interval"].length; k++) {

                            if (this.buildDates[i]["interval"][k] == interval[val]) {

                                this.buildDates[i]["interval"].splice(k, 1);

                            }
                        }

                        if (this.buildDates[i]["interval"].length <= 0) {
                            delete this.buildDates[i];
                        }

                    } else {

                    }
                }

            }

        } else {

            for (let i in this.buildDates) {

                // Если есть интервал
                if (this.buildDates[i]["interval"]) {

                    // Запускаем цикл по интервалу 
                    for (let k = 0; k < this.buildDates[i]["interval"].length; k++) {

                        if (this.buildDates[i]["interval"][k] == key) {
                            this.buildDates[i]["interval"].splice(k, 1);
                        }
                    }
                    if (this.buildDates[i]["interval"].length <= 0) {
                        delete this.buildDates[i];
                    }


                } else {

                }
            }
        }
        if (interval.length) {
            data["interval"] = interval;
        } else {
            data["interval"] = [key];
        }

        this.buildDates[key] = data;



    }
    setNewPrice(newPrice, datElement) {

        if (this.buildDates[datElement]) {
            if (this.buildDates[datElement]["interval"]) {
                for (let i = 0; i < this.buildDates[datElement]["interval"].length; i++) {
                    if (this.buildDates[datElement]["interval"][i] == datElement) {

                        const cloneFood = JSON.parse(JSON.stringify(this.buildDates[datElement]));

                        this.buildDates[datElement]["interval"].splice(i, 1);
                        this.buildDates[this.buildDates[datElement]["interval"][0]] = cloneFood;
                        delete cloneFood["interval"];
                        cloneFood["repeat-price"] = newPrice;

                        if (this.buildDates[datElement]["interval"].length <= 0) {
                            delete this.buildDates[datElement];
                        }
                        break;
                    }
                }

            } else {

                this.buildDates[datElement]["repeat-price"] = newPrice;
            }

        } else {

            for (let date in this.buildDates) {

                if (this.buildDates[date]["interval"]) {
                    for (let i = 0; i < this.buildDates[date]["interval"].length; i++) {
                        if (this.buildDates[date]["interval"][i] == datElement) {
                            const cloneFood = JSON.parse(JSON.stringify(this.buildDates[date]));
                            delete cloneFood["interval"];
                            cloneFood["repeat-price"] = newPrice;
                            this.buildDates[datElement] = cloneFood;
                            this.buildDates[date]["interval"].splice(i, 1);
                            if (this.buildDates[date]["interval"].length <= 0) {
                                delete this.dates[date];
                                delete this.buildDates[date];
                            }
                            break;
                        }
                    }

                }
            }
        }

    }
    checkOrderedDate(type) {
        let datesDelete = [];
        if (this.dateForDelete) {

            switch (type) {
                // Удалить текущий
                case "current":
                    // Если есть элемент с таким ключем 
                    if (this.buildDates[this.dateForDelete]) {
                        // Если у элемента есть интервал дат
                        if (this.buildDates[this.dateForDelete]["interval"]) {
                            for (let i = 0; i < this.buildDates[this.dateForDelete]["interval"].length; i++) {
                                if (this.buildDates[this.dateForDelete]["interval"][i] == this.dateForDelete) {
                                    datesDelete.push(this.buildDates[this.dateForDelete]["interval"][i]);
                                    break;
                                }
                            }
                            // Если интервала дат нет
                        } else {
                            datesDelete.push(this.dateForDelete);
                        }
                        // Если нет элемента с таким ключем 
                    } else {
                        // Ищем выбранную дату по всем интервалам элементов
                        for (let date in this.buildDates) {
                            if (this.buildDates[date]["interval"]) {
                                for (let i = 0; i < this.buildDates[date]["interval"].length; i++) {
                                    if (this.buildDates[date]["interval"][i] == this.dateForDelete) {
                                        datesDelete.push(this.buildDates[date]["interval"][i]);
                                    }
                                }

                            }
                        }
                    }
                    break;
                case "after":



                    for (let date in this.buildDates) {

                        if (parseInt(date) >= parseInt(this.dateForDelete)) {

                            if (this.buildDates[date]["interval"]) {
                                for (let i = 0; i < this.buildDates[date]["interval"].length; i++) {
                                    if (this.buildDates[date]["interval"][i] >= this.dateForDelete) {
                                        for (let k = i; k < this.buildDates[date]["interval"].length; k++) {
                                            datesDelete.push(this.buildDates[date]["interval"][k]);
                                        }
                                    }
                                }
                            } else {
                                datesDelete.push(this.dateForDelete);

                            }

                        } else {

                            if (this.buildDates[date]["interval"]) {
                                for (let i = 0; i < this.buildDates[date]["interval"].length; i++) {
                                    if (this.buildDates[date]["interval"][i] >= this.dateForDelete) {
                                        datesDelete.push(this.buildDates[date]["interval"][i]);
                                    }
                                }
                            }


                        }
                    }


                    break;

                case "after-week-day":


                    let daysWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
                    let deleteNameWeekDate = daysWeek[new Date(new Date().setTime(this.dateForDelete)).getDay()];


                    for (let date in this.buildDates) {

                        if (parseInt(date) >= parseInt(this.dateForDelete)) {

                            if (this.buildDates[date]["interval"]) {
                                for (let i = 0; i < this.buildDates[date]["interval"].length; i++) {
                                    let intervalWeekDate = daysWeek[new Date(new Date().setTime(this.buildDates[date]["interval"][i])).getDay()];
                                    if (this.buildDates[date]["interval"][i] >= this.dateForDelete && deleteNameWeekDate == intervalWeekDate) {
                                        for (let k = i; k < this.buildDates[date]["interval"].length; k++) {
                                            datesDelete.push(this.buildDates[date]["interval"][k]);
                                        }
                                    }
                                }
                            } else {
                                datesDelete.push(this.dateForDelete);

                            }

                        } else {

                            if (this.buildDates[date]["interval"]) {
                                for (let i = 0; i < this.buildDates[date]["interval"].length; i++) {
                                    let intervalWeekDate = daysWeek[new Date(new Date().setTime(this.buildDates[date]["interval"][i])).getDay()];
                                    if (this.buildDates[date]["interval"][i] >= this.dateForDelete && this.dateForDelete && deleteNameWeekDate == intervalWeekDate) {
                                        datesDelete.push(this.buildDates[date]["interval"][i]);
                                    }
                                }
                            }


                        }
                    }

                    break;
                case "period":
                    let start = $("input[name='cel-delete-period-start']");
                    let end = $("input[name='cel-delete-period-end']");


                    if (!start.attr("data-datetime")) {
                        new Notify("Заполните дату начала ", "alert");
                        start.addClass("is-invalid-input");
                        break;
                    } else {
                        start.removeClass("is-invalid-input");
                    }

                    if (!end.attr("data-datetime")) {
                        new Notify("Заполните дату окончания ", "alert");
                        end.addClass("is-invalid-input");
                        break;
                    } else {
                        end.removeClass("is-invalid-input");
                    }

                    let startDate = new Date(new Date().setTime(start.attr("data-datetime")));
                    let EndDate = new Date(new Date().setTime(end.attr("data-datetime")));
                    let range = [];

                    while (startDate <= EndDate) {
                        range.push(startDate.getTime());
                        startDate.setDate(startDate.getDate() + 1)
                    }

                    for (let date in this.buildDates) {


                        for (let j in range) {
                            if (range[j] == date) {
                                if (this.buildDates[date]["interval"]) {
                                    for (let i = 0; i < this.buildDates[date]["interval"].length; i++) {
                                        if (range[j] == this.buildDates[date]["interval"][i]) {
                                            datesDelete.push(this.buildDates[date]["interval"][i]);
                                        }
                                    }

                                } else {
                                    datesDelete.push(date);
                                }
                            } else {
                                if (this.buildDates[date]["interval"]) {

                                    for (let i = 0; i < this.buildDates[date]["interval"].length; i++) {

                                        for (let j in range) {
                                            if (range[j] == this.buildDates[date]["interval"][i]) {
                                                datesDelete.push(this.buildDates[date]["interval"][i]);
                                            }
                                        }


                                    }
                                }
                            }
                        }

                    }



                    break;


                    //  Удалить все 
                case "all":
                    // Если есть элемент с таким ключем 
                    if (this.buildDates[this.dateForDelete]) {
                        // Если у элемента есть интервал дат
                        if (this.buildDates[this.dateForDelete]["interval"]) {
                            for (let i = 0; i < this.buildDates[this.dateForDelete]["interval"].length; i++) {
                                datesDelete.push(this.buildDates[this.dateForDelete]["interval"][i]);
                            }
                            // Если интервала дат нет
                        } else {
                            datesDelete.push(this.dateForDelete);
                        }

                        // Если нет элемента с таким ключем 
                    } else {
                        // Ищем выбранную дату по всем интервалам элементов
                        for (let date in this.buildDates) {
                            if (this.buildDates[date]["interval"]) {
                                for (let i = 0; i < this.buildDates[date]["interval"].length; i++) {
                                    if (this.buildDates[date]["interval"][i] == this.dateForDelete) {
                                        for (let k = 0; k < this.buildDates[date]["interval"].length; k++) {
                                            datesDelete.push(this.buildDates[date]["interval"][k]);
                                        }
                                    }
                                }
                            }
                        }
                    }

                    break;
                default:
                    break;
            }
        }

        return datesDelete;
    }

    checkEventSuccess() {

        let container = $("#event-modal-success");
        $(".event-close-modal-success").on("click", function(e) {
            e.preventDefault();
            container.hide(150);
        });
        container.show(150);
        let timer = document.createElement("span");
        let seconds = 10;
        timer.innerHTML = seconds;
        $("#event-modal-timer").html(timer);
        $(".event-seconds-action").css({ "color": "#58cc64" });
        $(".event-seconds-action").html(timer);

        return new Promise(resolve => {

            let interval = setInterval(function() {

                if (seconds >= 7 && seconds <= 10) {
                    $(".event-seconds-action").css({ "color": "#58cc64" });
                }
                if (seconds >= 4 && seconds <= 7) {
                    $(".event-seconds-action").css({ "color": "#eeb301" });
                }
                if (seconds >= 0 && seconds <= 4) {
                    $(".event-seconds-action").css({ "color": "#a53b2a" });
                }

                --seconds;

                if (seconds == 0) {
                    timer.innerHTML = seconds;
                    container.hide(150);
                    clearInterval(interval);
                    resolve();
                }

                timer.innerHTML = seconds;

            }, 1000);

            $(".event-cancel-action").on("click", function(e) {
                e.preventDefault();
                clearInterval(interval);
                container.hide(150);
            });
        });
        return new Promise(resolve => {});
    }
    deleteDate(type) {
        if (this.dateForDelete) {
            let check = false;
            switch (type) {
                // Удалить текущий
                case "current":
                    check = false;
                    // Если есть элемент с таким ключем 
                    if (this.buildDates[this.dateForDelete]) {
                        // Если у элемента есть интервал дат
                        if (this.buildDates[this.dateForDelete]["interval"]) {
                            for (let i = 0; i < this.buildDates[this.dateForDelete]["interval"].length; i++) {
                                if (this.buildDates[this.dateForDelete]["interval"][i] == this.dateForDelete) {
                                    $($("[data-key='" + this.buildDates[this.dateForDelete]["interval"][i] + "']")[0]).removeClass("hide");
                                    $($("[data-key='" + this.buildDates[this.dateForDelete]["interval"][i] + "']")[1]).remove();
                                    let params = this.buildDates[this.dateForDelete];

                                    check = true;
                                    this.buildDates[this.dateForDelete]["interval"].splice(i, 1);
                                    if (this.buildDates[this.dateForDelete]["interval"][0] && this.buildDates[this.dateForDelete]["interval"].length) {
                                        this.buildDates[this.buildDates[this.dateForDelete]["interval"][0]] = params;
                                    }

                                    if (this.buildDates[this.dateForDelete]["interval"].length <= 0) {
                                        delete this.buildDates[this.dateForDelete];
                                    }


                                    break;
                                }
                            }
                            // Если интервала дат нет
                        } else {

                            $($("[data-key='" + this.dateForDelete + "']")[0]).removeClass("hide");
                            $($("[data-key='" + this.dateForDelete + "']")[1]).remove();
                            delete this.buildDates[this.dateForDelete];
                            delete this.dates[this.dateForDelete];
                            check = true;
                        }
                        // Если нет элемента с таким ключем 
                    } else {
                        // Ищем выбранную дату по всем интервалам элементов
                        for (let date in this.buildDates) {
                            if (this.buildDates[date]["interval"]) {

                                for (let i = 0; i < this.buildDates[date]["interval"].length; i++) {
                                    if (this.buildDates[date]["interval"][i] == this.dateForDelete) {
                                        $($("[data-key='" + this.buildDates[date]["interval"][i] + "']")[0]).removeClass("hide");
                                        $($("[data-key='" + this.buildDates[date]["interval"][i] + "']")[1]).remove();

                                        this.buildDates[date]["interval"].splice(i, 1);

                                        check = true;

                                        if (this.buildDates[date]["interval"].length <= 0) {
                                            delete this.dates[date];
                                            delete this.buildDates[date];
                                        }

                                        break;
                                    }
                                }

                            }
                        }
                    }


                    if (check) {
                        new Notify("Дата успешно удалена", "success");
                    }

                    break;
                case "after":
                    //  Удалить текущее и последующие 
                    check = false;

                    for (let date in this.buildDates) {
                        if (parseInt(date) >= parseInt(this.dateForDelete)) {

                            if (this.buildDates[date]["interval"]) {
                                for (let i = 0; i < this.buildDates[date]["interval"].length; i++) {

                                    $($("[data-key='" + this.buildDates[date]["interval"][i] + "']")[0]).removeClass("hide");
                                    $($("[data-key='" + this.buildDates[date]["interval"][i] + "']")[1]).remove();
                                }

                            } else {

                                $($("[data-key='" + date + "']")[0]).removeClass("hide");
                                $($("[data-key='" + date + "']")[1]).remove();

                                delete this.buildDates[date];
                                delete this.dates[date];
                                check = true;
                            }


                        } else {

                            if (this.buildDates[date]["interval"]) {

                                for (let i = 0; i < this.buildDates[date]["interval"].length; i++) {

                                    if (parseInt(this.buildDates[date]["interval"][i]) >= parseInt(this.dateForDelete)) {
                                        let params = [];
                                        params = this.buildDates[date];

                                        for (let k = i; k < this.buildDates[date]["interval"].length; k++) {

                                            check = true;
                                            $($("[data-key='" + this.buildDates[date]["interval"][k] + "']")[0]).removeClass("hide");
                                            $($("[data-key='" + this.buildDates[date]["interval"][k] + "']")[1]).remove();
                                        }

                                        this.buildDates[date]["interval"].splice(i);


                                        if (this.buildDates[date]["interval"][0] && this.buildDates[date]["interval"].length) {
                                            this.buildDates[this.buildDates[date]["interval"][0]] = params;
                                        }


                                        if (this.buildDates[date]["interval"].length <= 0) {
                                            delete this.dates[date];
                                            delete this.buildDates[date];
                                        }




                                        break;

                                    }
                                }
                            }

                        }
                    }

                    if (check) {

                        new Notify("Даты успешно удалены", "success");
                    }

                    break;


                case "after-week-day":

                    let daysWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
                    let deleteNameWeekDate = daysWeek[new Date(new Date().setTime(this.dateForDelete)).getDay()];





                    for (let date in this.buildDates) {
                        let weekDayMain = daysWeek[new Date(new Date().setTime(date)).getDay()];
                        if (parseInt(date) >= parseInt(this.dateForDelete) && deleteNameWeekDate == weekDayMain) {

                            if (this.buildDates[date]["interval"]) {

                                for (let i = 0; i < this.buildDates[date]["interval"].length; i++) {
                                    let weekDayInterval = daysWeek[new Date(new Date().setTime(this.buildDates[date]["interval"][i])).getDay()];
                                    if (parseInt(this.buildDates[date]["interval"][i]) >= parseInt(this.dateForDelete) && weekDayInterval == deleteNameWeekDate) {



                                        let params = [];
                                        params = this.buildDates[date];



                                        $($("[data-key='" + this.buildDates[date]["interval"][i] + "']")[0]).removeClass("hide");
                                        $($("[data-key='" + this.buildDates[date]["interval"][i] + "']")[1]).remove();



                                        this.buildDates[date]["interval"].splice(i, 1);

                                        check = true;

                                        if (this.buildDates[date]["interval"][0] && this.buildDates[date]["interval"].length) {
                                            this.buildDates[this.buildDates[date]["interval"][0]] = params;
                                        }

                                        if (this.buildDates[date]["interval"].length <= 0) {
                                            delete this.dates[date];
                                            delete this.buildDates[date];
                                        }

                                    }
                                }

                            } else {
                                $($("[data-key='" + date + "']")[0]).removeClass("hide");
                                $($("[data-key='" + date + "']")[1]).remove();

                                delete this.buildDates[date];
                                delete this.dates[date];
                                check = true;
                            }



                        } else {

                            if (this.buildDates[date]["interval"]) {

                                for (let i = 0; i < this.buildDates[date]["interval"].length; i++) {
                                    let weekDayInterval = daysWeek[new Date(new Date().setTime(this.buildDates[date]["interval"][i])).getDay()];
                                    if (parseInt(this.buildDates[date]["interval"][i]) >= parseInt(this.dateForDelete) && weekDayInterval == deleteNameWeekDate) {



                                        let params = [];
                                        params = this.buildDates[date];



                                        $($("[data-key='" + this.buildDates[date]["interval"][i] + "']")[0]).removeClass("hide");
                                        $($("[data-key='" + this.buildDates[date]["interval"][i] + "']")[1]).remove();



                                        this.buildDates[date]["interval"].splice(i, 1);

                                        check = true;

                                        if (this.buildDates[date]["interval"][0] && this.buildDates[date]["interval"].length) {
                                            this.buildDates[this.buildDates[date]["interval"][0]] = params;
                                        }

                                        if (this.buildDates[date]["interval"].length <= 0) {
                                            delete this.dates[date];
                                            delete this.buildDates[date];
                                        }

                                    }
                                }
                            }

                        }
                    }



                    if (check) {

                        new Notify("Даты успешно удалены", "success");
                    }

                    break;


                case "period":

                    let start = $("input[name='cel-delete-period-start']");
                    let end = $("input[name='cel-delete-period-end']");

                    let startDate = new Date(new Date().setTime(start.attr("data-datetime")));
                    let EndDate = new Date(new Date().setTime(end.attr("data-datetime")));
                    let range = [];

                    while (startDate <= EndDate) {
                        range.push(startDate.getTime());
                        startDate.setDate(startDate.getDate() + 1)
                    }


                    for (let date in this.buildDates) {
                        for (let j in range) {
                            if (range[j] == date) {

                                if (this.buildDates[date]["interval"]) {

                                    for (let i = 0; i < this.buildDates[date]["interval"].length; i++) {


                                        for (let k in range) {
                                            if (range[k] == this.buildDates[date]["interval"][i]) {


                                                let params = [];
                                                params = this.buildDates[date];



                                                $($("[data-key='" + this.buildDates[date]["interval"][i] + "']")[0]).removeClass("hide");
                                                $($("[data-key='" + this.buildDates[date]["interval"][i] + "']")[1]).remove();



                                                this.buildDates[date]["interval"].splice(i, 1);

                                                check = true;

                                                if (this.buildDates[date]["interval"][0] && this.buildDates[date]["interval"].length) {
                                                    this.buildDates[this.buildDates[date]["interval"][0]] = params;
                                                }

                                                if (this.buildDates[date]["interval"].length <= 0) {
                                                    delete this.dates[date];
                                                    delete this.buildDates[date];
                                                }
                                            }
                                        }




                                    }

                                } else {
                                    $($("[data-key='" + date + "']")[0]).removeClass("hide");
                                    $($("[data-key='" + date + "']")[1]).remove();

                                    delete this.buildDates[date];
                                    delete this.dates[date];
                                    check = true;
                                }
                            } else {
                                if (this.buildDates[date]["interval"]) {

                                    for (let i = 0; i < this.buildDates[date]["interval"].length; i++) {


                                        for (let k in range) {
                                            if (range[k] == this.buildDates[date]["interval"][i]) {


                                                let params = [];
                                                params = this.buildDates[date];



                                                $($("[data-key='" + this.buildDates[date]["interval"][i] + "']")[0]).removeClass("hide");
                                                $($("[data-key='" + this.buildDates[date]["interval"][i] + "']")[1]).remove();



                                                this.buildDates[date]["interval"].splice(i, 1);

                                                check = true;

                                                if (this.buildDates[date]["interval"][0] && this.buildDates[date]["interval"].length) {
                                                    this.buildDates[this.buildDates[date]["interval"][0]] = params;
                                                }

                                                if (this.buildDates[date]["interval"].length <= 0) {
                                                    delete this.dates[date];
                                                    delete this.buildDates[date];
                                                }
                                            }
                                        }
                                    }
                                }
                            }

                        }
                    }


                    if (check) {

                        new Notify("Даты успешно удалены", "success");
                    }
                    break;

                case "all":
                    check = false;
                    // Если есть элемент с таким ключем 
                    if (this.buildDates[this.dateForDelete]) {
                        // Если у элемента есть интервал дат
                        if (this.buildDates[this.dateForDelete]["interval"]) {
                            for (let i = 0; i < this.buildDates[this.dateForDelete]["interval"].length; i++) {
                                check = true;
                                $($("[data-key='" + this.buildDates[this.dateForDelete]["interval"][i] + "']")[0]).removeClass("hide");
                                $($("[data-key='" + this.buildDates[this.dateForDelete]["interval"][i] + "']")[1]).remove();
                            }
                            // Если интервала дат нет
                        } else {
                            check = true;
                            $($("[data-key='" + this.dateForDelete + "']")[0]).removeClass("hide");
                            $($("[data-key='" + this.dateForDelete + "']")[1]).remove();

                        }
                        delete this.buildDates[this.dateForDelete];
                        delete this.dates[this.dateForDelete];
                        // Если нет элемента с таким ключем 
                    } else {
                        // Ищем выбранную дату по всем интервалам элементов
                        for (let date in this.buildDates) {

                            if (this.buildDates[date]["interval"]) {

                                for (let i = 0; i < this.buildDates[date]["interval"].length; i++) {

                                    if (this.buildDates[date]["interval"][i] == this.dateForDelete) {

                                        for (let k = 0; k < this.buildDates[date]["interval"].length; k++) {
                                            $($("[data-key='" + this.buildDates[date]["interval"][k] + "']")[0]).removeClass("hide");
                                            $($("[data-key='" + this.buildDates[date]["interval"][k] + "']")[1]).remove();
                                            check = true;
                                        }

                                        delete this.dates[date];
                                        delete this.buildDates[date];

                                        break;
                                    }


                                }
                            }
                        }

                    }

                    if (check) {
                        new Notify("Даты успешно удалены", "success");
                    }


                    break;
                default:
                    break;
            }
            // this.rebuildDays();
        }
        // this.dateForDelete = null;
    }

    clearRepeatForm() {




        $("input[name='repeat-price']").val("");
        $("#block-repeat").addClass("hide");
        $("#norepeat").prop("checked", true);
        $(".repeat-type option[value='week']").prop('selected', true);
        $(".mounthly-repeat-container").addClass("hide");
        $(".days-repeat-container").removeClass("hide");
        $("input[name='repeat-end']").first().prop("checked", true);
        $("input[name='count-end']").attr("disabled", true);
        $("input[name='end-data']").attr("disabled", true);
        $("input[name='repeat-day']").val(1);



        // this.reInitLitepicker();

    }
    serializeDataRepeatForm() {
        let data = $("#" + this.popupId).find("input,select,textarea").serializeArray();
        let res = {};
        let requiredFlag = false;

        data.forEach((element) => {
            let input = $("[name='" + element.name + "']");

            if (input.data("required") == "Y") {
                if (!input.val().trim() || input.val().trim().length == 0 || input.val() == 0) {
                    input.addClass("is-invalid-input");
                    input.parent("label").addClass("is-invalid-label");
                    requiredFlag = true;
                } else {
                    input.removeClass("is-invalid-input");
                    input.parent("label").removeClass("is-invalid-label");
                }
            }

            res[element.name] = element.value;
        });

        if (!requiredFlag) {
            return res;
        } else {
            new Notify("Пожалуйста, заполните обязательные поля", "alert");
            return false;
        }


    }

    getDateForRepeat() {
        let instance = this;
        let startDate = new Date();
        let countRepeat = $("input[name='count-end']").val();
        let type = $(".repeat-type").val();
        let globalDateCreateStart = new Date(instance.globalDateCreateStart);
        switch (type) {
            case "day":
                startDate = new Date(globalDateCreateStart.setDate(globalDateCreateStart.getDate() + parseInt(countRepeat)));
                break;
            case "week":
                startDate = new Date(globalDateCreateStart.setDate(globalDateCreateStart.getDate() + (parseInt(countRepeat) * 7)));
                break;
            case "mounth":
                startDate = new Date(globalDateCreateStart.setMonth(globalDateCreateStart.getMonth() + parseInt(countRepeat)));
                break;
            case "year":
                startDate = new Date(globalDateCreateStart.setFullYear(globalDateCreateStart.getFullYear() + parseInt(countRepeat)));
                break;

            default:

                break;

        }

        return startDate;
    }
    initSendFormAction() {


        var ObjectCreate = function(form, dates) {
            this.dataArray = [];
            this.dataCalendar = [];
            this.requiredError = false;
            this.form = form;
            let data = $(form).serializeArray();

            data.forEach((element) => {
                if (element.name.indexOf("repeat") != -1) {
                    return;
                }
                let input = $("[name='" + element.name + "']");



                if (input.data("required") == "Y") {

                    if (!input.val().trim() || input.val().trim().length == 0) {
                        input.addClass("is-invalid-input");
                        input.parent("label").addClass("is-invalid-label");
                        this.requiredError = true;
                    } else {
                        input.removeClass("is-invalid-input");
                        input.parent("label").removeClass("is-invalid-label");
                    }
                }

                this.dataArray.push(element);
            });
            if (!$("[name='location']").val()) {
                $("[name='location']").addClass("is-invalid-input");
                this.requiredError = true;
            } else {
                $("[name='location']").removeClass("is-invalid-input");
            }

            this.requiredErrorDates = false;
            if ($.isEmptyObject(dates)) {
                this.requiredErrorDates = true;


            }
            this.dataArray.push({ name: "material_id", value: $(form).attr("data-id") });
            this.dataArray.push({ name: "full_dates", value: dates });

        }
        ObjectCreate.prototype.send = function(ajaxUrl = false) {
            let action = "ObjectCreate";
            if (!ajaxUrl) {
                ajaxUrl = "/themes/ahtilahti/ajax/object_create.php";
            } else {
                action = "ObjectEdit";
            }

            // Проверим, существует ли такой инвентарный номер\
            let checkInventoryNumber = true;
            if ($("input[name='inventoryNumber']").val().trim() == 0) {
                $("input[name='inventoryNumber']").addClass("is-invalid-input");
                new Notify("Пожалуйста, заполните обязательные поля", "alert");
                return;
            } else {
                $("input[name='inventoryNumber']").removeClass("is-invalid-input");
            }

            $.ajax({
                method: "POST",
                url: "/themes/ahtilahti/ajax/object_edit.php",
                async: false,
                data: {
                    action: "check-unique-number",
                    data: $("input[name='inventoryNumber']").val(),
                    id: $(".object-edit").attr("data-id"),
                },
                success: function(response) {
                    let res;
                    typeof response === "string" ?
                        (res = $.parseJSON(response)) :
                        (res = response);


                    if (res.success == false) {
                        checkInventoryNumber = false;
                    }
                },
                error(xhr, status, error) {
                    console.log(xhr);
                },

            });

            if (!checkInventoryNumber) {
                $("input[name='inventoryNumber']").addClass("is-invalid-input");
                new Notify("Такой инвентарный номер уже существует", "alert");
                return;
            } else {
                $("input[name='inventoryNumber']").removeClass("is-invalid-input");
            }
            if (!this.requiredError && !this.requiredErrorDates) {
                $.ajax({
                    method: "POST",
                    url: ajaxUrl,
                    data: {
                        action: action,
                        data: this.dataArray,
                    },
                    success: function(response) {

                        let res;
                        typeof response === "string" ?
                            (res = $.parseJSON(response)) :
                            (res = response);
                        if (res.success == true) {


                            new Notify(res.message, "success");
                            document.location.href = res.link;
                        } else {
                            new Notify(res.message, "alert");
                        }
                    },
                    error(xhr, status, error) {
                        console.log(xhr);
                    },
                });


            } else {
                if (this.requiredError) {
                    new Notify("Пожалуйста, заполните обязательные поля", "alert");
                }
                if (this.requiredErrorDates) {
                    new Notify("Необходимо добавить даты аренды", "alert");
                }


            }

        }


        let instance = this;
        let formCreate = ".object-create";
        $(formCreate).on("submit", function(e) {
            e.preventDefault();
            var create = new ObjectCreate(this, instance.buildDates);
            create.send();

        });

        let formEdit = ".object-edit";
        $(formEdit).on("submit", function(e) {
            e.preventDefault();


            var edit = new ObjectCreate(this, instance.buildDates);

            edit.send("/themes/ahtilahti/ajax/object_edit.php");

        });



    }
    init(calendar = false) {
        let instance = this;
        if ($("#" + instance.idContainer).length) {
            let mounth = instance.createMonth();
            let days = instance.createDays();
            let weekDays = instance.createWeekDays();
            if (calendar) {
                instance.calendar = document.createElement("div");
                instance.calendar.classList.add("calendar");
            }
            instance.calendar.appendChild(mounth);
            instance.calendar.appendChild(weekDays);
            instance.calendar.appendChild(days);

            $("#" + instance.idContainer).html(instance.calendar);
            if (!instance.repeatDataIsActive) {
                instance.initRepeatData();
                instance.initSendFormAction();
            }

            instance.rebuildDays();




        }

    }


}
(function($) {


    $("[data-datepicker-delete-start]").each(function() {
        new Litepicker({
            element: this,
            lang: "ru-RU",
            format: "D MMM, YYYY",
            singleMode: true,
            minDate: new Date(new Date().setDate(new Date().getDate() - 1)),
            onShow: function() {

                let offset = $("[data-datepicker-delete-start]").offset();
                let heightField = $("[data-datepicker-delete-start]").outerHeight();
                $(this.picker).css({ top: offset.top + heightField + "px", position: "fixed" });

            },
            onSelect: function(date) {
                $("[data-datepicker-delete-start]").attr("data-dateTime", new Date(date).getTime());

            },

        });
    });

    $("[data-datepicker-delete-end]").each(function() {
        new Litepicker({
            element: this,
            lang: "ru-RU",
            format: "D MMM, YYYY",
            singleMode: true,
            minDate: new Date(new Date().setDate(new Date().getDate() - 1)),
            onShow: function() {
                let offset = $("[data-datepicker-delete-end]").offset();
                let heightField = $("[data-datepicker-delete-end]").outerHeight();
                $(this.picker).css({ top: offset.top + heightField + "px", position: "fixed" });


            },
            onSelect: function(date) {
                $("[data-datepicker-delete-end]").attr("data-dateTime", new Date(date).getTime());

            },
        });
    });



    $("input[name='cell-delete']").on("change", function(e) {
        e.preventDefault();

        if ($(this).val() == "period") {
            $("#block-period").removeClass("hide");
        } else {
            $("#block-period").addClass("hide");
        }
    });

    var Upload = function(file, input) {
        this.file = file;
        this.input = input;

    };

    Upload.prototype.getName = function() {
        return this.file.name;
    };


    Upload.prototype.doUpload = function() {
        var that = this;
        var formData = new FormData();
        formData.append("file", this.file, this.getName());
        formData.append("action", "upload");
        formData.append("upload_file", true);
        $.ajax({
            type: "POST",
            url: "/cms/include/action_files.php",
            xhr: function() {
                var myXhr = $.ajaxSettings.xhr();
                if (myXhr.upload) {
                    myXhr.upload.addEventListener('progress', function(event) {
                        var percent = 0;
                        var position = event.loaded || event.position;
                        var total = event.total;
                        var progress_bar = $(that.input).siblings(".progress-wrp");

                        if (event.lengthComputable) {
                            percent = Math.ceil(position / total * 100);
                        }
                        progress_bar.find(".progress-bar").css("width", +percent + "%");
                    }, false);
                }
                return myXhr;
            },
            success: function(response) {
                let res;
                typeof response === "string" ?
                    (res = $.parseJSON(response)) :
                    (res = response);
                if (res.success == false) {
                    new Notify("Ошибка. Неподходящий размер или расширение файла", "alert");
                    $(that.input).siblings("label").text("Загрузите картинку");
                    $(that.input).siblings(".progress-wrp").find(".progress-bar").css({ "width": "0" });
                    $(that.input).closest(".file-field-wrapper").css({ "background-image": "none" });
                    document.getElementById($(that.input).siblings("label").attr("for")).value = "";
                    $(that.input).closest(".file-field-wrapper").find(".file-upload-custom").attr("value", "");
                    $(that.input).closest(".file-field-wrapper").find(".file-uploaded").attr("value", "");

                } else {
                    let newFile = res.path + res.file;
                    $(that.input).siblings(".progress-wrp").find(".progress-bar").css({ "width": "0" });
                    $(that.input).closest(".file-field-wrapper").css({ "background-image": "url(" + newFile + ")" });
                    $(that.input).siblings(".file-uploaded").attr("value", newFile);
                    $(that.input).closest(".file-field-wrapper").append('<button type="button" class="button-close-file" data-close aria-label="Закрыть"><span aria-hidden="true">&times;</span></button>');
                }

            },
            error(xhr, status, error) {
                new Notify(error, "alert");
            },
            async: true,
            data: formData,
            cache: false,
            contentType: false,
            processData: false,
            timeout: 60000
        });

    }
    $('.file-upload-custom').on("change", function() {
        if ($(this).val()) {

            $(this).siblings("label").text("");
            var file = $(this)[0].files[0];
            var input = this;
            var upload = new Upload(file, input);
            upload.doUpload();
        }
    });

    $(".object-create input[type='number']").on("keypress", function() {

        if ($(this).attr("maxlength")) {
            if (parseInt($(this).val().length) >= parseInt($(this).attr("maxlength"))) {
                return false;
            }
        }
    });


    $(".file-field-plus").on("click", function() {
        let item = $(".file-field-wrapper");


        item.each(function(index) {
            if ($(this).hasClass("hide")) {
                $(this).removeClass("hide");
                return false;
            }
        });

        if (!$(item).hasClass("hide")) {
            $(".file-field-plus").addClass("hide");

        }
    });

    $(document).on("click", ".button-close-file", function(e) {
        e.preventDefault();
        $(this).siblings("label").text("Загрузите картинку");
        document.getElementById($(this).siblings("label").attr("for")).value = "";
        $(this).siblings(".progress-wrp").find(".progress-bar").css({ "width": "0" });
        $(this).closest(".file-field-wrapper").find(".file-upload-custom").attr("value", "");
        $(this).closest(".file-field-wrapper").find(".file-uploaded").attr("value", "");
        $(this).closest(".file-field-wrapper").css({ "background-image": "none" });
        $(this).remove();
    });



})(jQuery);
//